var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Editor as DraftEditor, EditorState, RichUtils, } from "draft-js";
import { Labelled } from "../Labelled";
import * as S from "./Editor.styled";
var toolbarOptions = [
    {
        tool: "BOLD",
        label: "Bold",
        isToggleTypeInline: true,
    },
    {
        tool: "ITALIC",
        label: "Italic",
        isToggleTypeInline: true,
    },
    {
        tool: "UNDERLINE",
        label: "Underline",
        isToggleTypeInline: true,
    },
    {
        tool: "CODE",
        label: "Code",
        isToggleTypeInline: true,
    },
    {
        tool: "header-one",
        label: "H1",
        isToggleTypeInline: false,
    },
    {
        tool: "header-two",
        label: "H2",
        isToggleTypeInline: false,
    },
    {
        tool: "unordered-list-item",
        label: "• List",
        isToggleTypeInline: false,
    },
    {
        tool: "ordered-list-item",
        label: "1. List",
        isToggleTypeInline: false,
    },
    {
        tool: "blockquote",
        label: "Quote",
        isToggleTypeInline: false,
    },
];
export var Editor = function (props) {
    var _a = props.editorState, editorState = _a === void 0 ? EditorState.createEmpty() : _a, onChange = props.onChange, helpText = props.helpText, error = props.error, label = props.label, maxLength = props.maxLength, errorMessageHidden = props.errorMessageHidden, labelHidden = props.labelHidden, optional = props.optional, onPressExtraInfo = props.onPressExtraInfo, restProps = __rest(props, ["editorState", "onChange", "helpText", "error", "label", "maxLength", "errorMessageHidden", "labelHidden", "optional", "onPressExtraInfo"]);
    var toggleInline = function (style) {
        return onChange(RichUtils.toggleInlineStyle(editorState, style));
    };
    var toggleBlock = function (blockType) {
        return onChange(RichUtils.toggleBlockType(editorState, blockType));
    };
    var text = editorState.getCurrentContent().getPlainText("");
    var length = text.length;
    var limitExceeded = maxLength !== undefined && length > maxLength;
    return (_jsxs(Labelled, { label: label, error: errorMessageHidden ? undefined : error, labelHidden: labelHidden, helpText: helpText, optional: optional, onPressExtraInfo: onPressExtraInfo, children: [_jsxs(S.EditorWrapper, { children: [_jsx(S.Toolbar, { children: toolbarOptions.map(function (option) { return (_jsx(S.ToolButton, { onMouseDown: function (e) {
                                e.preventDefault();
                                option.isToggleTypeInline
                                    ? toggleInline(option.tool)
                                    : toggleBlock(option.tool);
                            }, children: option.label }, option.tool)); }) }), _jsx(S.EditorContainer, { children: _jsx(DraftEditor, __assign({ editorState: editorState, onChange: onChange }, restProps)) })] }), helpText && _jsx("div", { children: helpText }), limitExceeded && (_jsx(S.ErrorText, { children: "".concat(length, "/").concat(maxLength, " characters \u2014 Maximum length exceeded") })), error && _jsx(S.ErrorText, { children: error })] }));
};
